// Centralised per-route SEO copy. ONE config object, consumed by the existing
// reusable <Seo> component (react-helmet-async). Titles are stored WITHOUT the
// " | AutoCareX" suffix — the Seo component appends it. Keyed by "/" (home) and
// by product slug (the app serves every product through one /product/:slug route).
//
// A single default OG image + base URL are reused across all routes (handled by
// the Seo component); only title/description vary per route here.
export const DEFAULT_OG_IMAGE = "/logo512.png";

export const SEO_CONFIG = {
  "/": {
    title: "Buy Car Care Products Online in India",
    description:
      "Shop AutoCareX professional car care — shampoo, wax, interior & wheel cleaners and more. Affordable, certified DIY car care delivered across India.",
  },
  "car-shampoo": {
    title: "Car Shampoo 250ml – High-Foam pH-Balanced Wash",
    description:
      "AutoCareX Car Shampoo (250ml): high-foam, pH-balanced formula that lifts dirt safely without stripping wax. Smart, affordable DIY car wash for Indian roads.",
  },
  "interior-cleaner": {
    title: "Car Interior Cleaner 250ml – Dashboard & Seats",
    description:
      "Clean dashboards, upholstery and trim with AutoCareX Interior Cleaner (250ml). Removes dust, stains and grime for a fresh, residue-free interior.",
  },
  "wheel-cleaner": {
    title: "Car Wheel & Alloy Cleaner 250ml",
    description:
      "AutoCareX Wheel Cleaner (250ml) dissolves brake dust and road grime from alloys and rims. Fast-acting, safe on finishes — DIY-easy wheel care.",
  },
  "windshield-wash": {
    title: "Windshield Washer Fluid 250ml – Streak-Free",
    description:
      "AutoCareX Windshield Wash (250ml) cuts through dirt, oil film and bug splatter for streak-free, clear visibility. Smart maintenance for safer driving.",
  },
  "waterless-wash": {
    title: "Waterless Car Wash 250ml – No-Rinse Spray",
    description:
      "Wash your car anywhere with AutoCareX Waterless Wash (250ml). No-rinse spray-and-wipe formula that cleans and shines while saving water.",
  },
  "dashboard-polish": {
    title: "Dashboard Polish 250ml – Shine & UV Protect",
    description:
      "AutoCareX Dashboard Polish (250ml) restores shine and protects interior plastics from UV fading and cracking. Non-greasy, long-lasting finish.",
  },
  "premium-liquid-wax": {
    title: "Premium Liquid Car Wax 250ml – Gloss & Protect",
    description:
      "Lock in deep gloss and paint protection with AutoCareX Premium Liquid Wax (250ml). Easy-on, easy-off for a showroom shine that lasts.",
  },
  "rust-remover-spray": {
    title: "Rust Remover Spray 250ml – Metal Protection",
    description:
      "AutoCareX Rust Remover Spray (250ml) dissolves rust and protects metal parts from corrosion. Quick-acting DIY solution for car maintenance.",
  },
  "ac-foam-duct-cleaner": {
    title: "Car AC Duct Foam Cleaner 250ml",
    description:
      "Freshen your car AC with AutoCareX Foam Duct Cleaner (250ml). Clears odour-causing buildup from vents and ducts for cleaner cabin air.",
  },
  "tyre-shine": {
    title: "Tyre Shine Spray 250ml – Long-Lasting Gloss",
    description:
      "AutoCareX Tyre Shine (250ml) gives tyres a deep black, long-lasting gloss while protecting rubber from cracking. Non-sling DIY tyre care.",
  },
  "micro-fiber-cloth": {
    title: "Microfibre Cloth for Car Cleaning & Detailing",
    description:
      "Soft, lint-free AutoCareX Microfibre Cloth for streak-free cleaning, drying and polishing. Scratch-safe on paint, glass and interiors.",
  },
};
